import React, { useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { MessagingGirlSVG } from '../../assets';
import { MessageCircle, BookOpen, Users } from 'react-feather';
import { ActionButton } from './ActionButton';
import { CONTACT_CREATE_PATH } from 'src/views/contacts/ContactsListView/constants';
import { SendOutboundMessageModal } from '../Conversation';
import { useTranslation } from 'react-i18next';

export const EmptyChat = ({
    onMessageSent,
}: {
    onMessageSent?: () => void;
}) => {
    const history = useHistory();

    const { t } = useTranslation();
    const [isOutboundModalOpen, setIsOutboundModalOpen] = useState(false);

    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                gap: 50,
            }}
        >
            <SendOutboundMessageModal
                open={isOutboundModalOpen}
                setOpen={setIsOutboundModalOpen}
                onMessageSent={onMessageSent}
            />

            <Typography variant="h2" color="textPrimary">
                {t('Chat.SelectChatToStart')}
            </Typography>
            <MessagingGirlSVG
                style={{
                    height: 200,
                }}
            />
            <Box
                style={{
                    display: 'flex',
                    gap: 30,
                }}
            >
                <ActionButton
                    icon={<MessageCircle />}
                    label={t('Chat.SendOutboundMessage')}
                    onClick={() => setIsOutboundModalOpen(true)}
                />
                <ActionButton
                    icon={<BookOpen />}
                    label={t('Chat.AddContact')}
                    onClick={() => history.push(CONTACT_CREATE_PATH)}
                />
                <ActionButton
                    icon={<Users />}
                    label={t('Chat.GoToMyContacts')}
                    onClick={() => history.push('/management/contacts')}
                />
                <ActionButton
                    icon={<BookOpen />}
                    label={t('Chat.AddContact')}
                />
            </Box>
        </Box>
    );
};
